const numberFormats = {
  number: {
    GBP: {
      style: 'currency',
      currency: 'GBP'
    },
    EUR: {
      style: 'currency',
      currency: 'EUR'
    }
  }
};

export default numberFormats;
